import { useAtomValue } from "jotai";
import { RiGroupLine, RiImage2Line } from "react-icons/ri";

import { useGetWhoami } from "@/api/whoami/get-whoami";
import { routePaths } from "@/config/route-paths";
import { sidebarCollapsedAtom } from "@/stores/layout";

import { IconAnalysisAssist } from "./icons";
import { SideNavItemLink } from "./SideNavItemLink";

const ICON_SIZE = 20;
/** サイドバーの配色（濃紺の地に載せる） */
const ICON_COLOR = "#F2F5FC";

/** 作業画面。ロールによる差は無い */
const workItems = (tenantId: string) => [
  {
    label: "画像ライブラリ",
    href: routePaths.tenants.imageLibrary.getHref(tenantId),
    icon: <RiImage2Line size={ICON_SIZE} className="text-[#F2F5FC]" />,
  },
  {
    label: "バナー分析",
    href: routePaths.tenants.bannerAnalysis.root.getHref(tenantId),
    icon: <IconAnalysisAssist />,
  },
  // レポートライブラリは機能を公開しないため導線を出さない。
  // 公開するときは connect-settings-routes.tsx のルートと
  // RiSlideshowLine の import も合わせて戻す
  // {
  //   label: "レポートライブラリ",
  //   href: routePaths.tenants.reportLibrary.getHref(tenantId),
  //   icon: <RiSlideshowLine size={ICON_SIZE} className="text-[#F2F5FC]" />,
  // },
];

/**
 * 管理領域への導線。ホストと管理者だけに出す。
 *
 * 出し分けの根拠は URL と揃える。`/tenants/:tenantId/manage/*` は
 * RequireRole が member を弾くため、見せても 403 になるだけ。
 */
const ManageSection = ({ tenantId }: { tenantId: string }) => {
  const { role } = useGetWhoami();
  const collapsed = useAtomValue(sidebarCollapsedAtom);

  if (role === "member") {
    return null;
  }

  return (
    <>
      <li aria-hidden="true" className="my-1 pr-2">
        <hr className="border-white/25" />
      </li>
      {!collapsed && (
        <li className="px-2 pt-1 text-Small leading-none text-white/60">
          管理
        </li>
      )}
      <li>
        <SideNavItemLink
          label="ユーザー管理"
          href={routePaths.tenants.manage.users.getHref(tenantId)}
          icon={<RiGroupLine size={ICON_SIZE} color={ICON_COLOR} />}
        />
      </li>
    </>
  );
};

export const TenantNavigation = ({ tenantId }: { tenantId: string }) => {
  return (
    <ul className="flex h-full flex-col gap-2">
      {workItems(tenantId).map((item) => (
        <li key={item.href}>
          <SideNavItemLink
            label={item.label}
            href={item.href}
            icon={item.icon}
          />
        </li>
      ))}

      <ManageSection tenantId={tenantId} />
    </ul>
  );
};
